import styled from "styled-components/macro";

export const ChangelogBtnWrapper = styled.span`
  button {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 4px;

    #fb-update-badge {
      padding: 0px 4px !important;
      height: unset !important;
      background-color: var(--primary-cta-high-contrast);
      border-radius: 50%;
      line-height: 16px;
      color: var(--menu-color);
    }
  }
`;
